// Mobile sticky footer CTA.
// Tied to the sticky header (see header-scroll.js): the bar is only up while the
// header is hidden — i.e. while the user is scrolling down the page — and drops
// away the moment scrolling up brings the header back. Whether it shows at all
// is gated to <=991px in CSS — this only toggles the class.
((window) => {
    const cta = document.querySelector('[data-behaviour="footer-cta"]');

    if (!cta) return;

    const header = document.querySelector('.header-main');

    // Distance scrolled (px) before the bar appears.
    const showAfter = 10;

    let ticking = false;

    const shouldShow = () => {
        if (window.scrollY <= showAfter) return false;

        // No sticky header on this page — fall back to "anything but the top".
        if (!header) return true;

        return header.classList.contains('header-main--hidden');
    };

    const update = () => {
        ticking = false;

        cta.classList[shouldShow() ? 'add' : 'remove']('footer-cta--visible');
    };

    const onScroll = () => {
        if (ticking) return;

        ticking = true;
        window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    // React to the header the instant it reveals, rather than waiting for the
    // next scroll frame — otherwise the bar lingers on the way back up.
    if (header && window.MutationObserver) {
        new window.MutationObserver(update).observe(header, {
            attributes: true,
            attributeFilter: ['class'],
        });
    }

    // Covers a reload part-way down the page.
    update();
})(window);
